<template>
  <div>
    <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Edit Modules</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <CInput
                  label="Name"
                  placeholder="Name"
                  name="ModuleName"
                  id="ModuleName"
                />
              </CCol>
              <CInput hidden name="Status" />
            </CRow>
            <!-- <CRow>
              <CCol sm="12">
                <CInput
                  label="Guard name"
                  placeholder="Guard name"
                />
              </CCol>
            </CRow>
			<CRow>
              <CCol sm="12">
				<CSelect
					label="Status"					
					:options="options"
					placeholder="Select Status" name="isactive_status"/>
				</CCol>
            </CRow>	 -->
            <CRow>
              <CCol sm="6">
                <button
                  aria-pressed="true"
                  type="button"
                  autocomplete="off"
                  class="btn btn-outline-light btn-block active fw-500 fs-18"
                  @click="back()"
                >
                  Cancel
                </button>
              </CCol>
              <CCol sm="6">
                <button
                  aria-pressed="true"
                  type="button"
                  autocomplete="off"
                  class="
                    btn btn-outline-info btn-block
                    active
                    fw-500
                    col-white
                    fs-18
                  "
                  @click="submit()"
                >
                  Update
                </button>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
//import { ModelSelect } from 'vue-search-select';
import axios from "axios";
export default {
  name: "Add_modules",
  data() {
    return {
      isLoading: false,
    };
  },
  mounted() {
    $(".counterDiv").hide();
    $(".otherOptions").hide();

    var edit_module_id = localStorage.getItem("edit_module_id");
    var token = localStorage.getItem("auth");
    var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));

    var requestInfo = {
      Module_Id: edit_module_id,
      Token: token,
      Session_User_Id: Session_User_Id,
    };
    console.log(requestInfo);
    var data = JSON.stringify(requestInfo);
    var self = this;
    var config = {
      method: "post",
      url: apiURL + "ManageModule/GetModuleDetails",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    this.isLoading = true;
    axios(config)
      .then((result) => {
        this.isLoading = false;
        if (result.data.status_code == 200) {
          var obj = result.data.response;
          //console.log(obj[0]);
          $("input[name=Module_Id]").val(obj[0].Module_Id);
          $("input[name=ModuleName]").val(obj[0].ModuleName);
          $("input[name=Status]").val(obj[0].Status);
          //$('#reponse_error').html(result.data.message);
        } else {
          //$('#reponse_error').html(result.data.message);
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.message,
          });
        }
      })
      .catch((error) => {
        this.isLoading = false;
        //var errorObject=JSON.stringify(error.response.data.errors);
        //console.log(errorObject);
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  },
  computed: {},
  methods: {
    validator(val) {
      return val ? val.length >= 4 : false;
    },
    back() {
      console.log("call");
      this.$router.push({ path: "manage_modules" });
    },
    submit() {
      var ModuleName = $("#ModuleName").val();
      // console.log(Role_Name);
      if (ModuleName == "") {
        this.$swal("Module Name is required");
        return false;
      }

      var Module_Id = JSON.parse(localStorage.getItem("edit_module_id"));
      var user = JSON.parse(localStorage.getItem("user"));
      var FirstName = user[0].FirstName;
      var LastName = user[0].LastName;
      var Status = $("input[name=Status]").val();
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
      var token = localStorage.getItem("auth");

      var requestInfo = {
        Module_Id: Module_Id,
        ModuleName: ModuleName,
        GuardName: FirstName + " " + LastName,
        Status: Status,
        Token: token,
        Session_User_Id: Session_User_Id,
      };
      console.log(requestInfo);

      var self = this;
      var data = JSON.stringify(requestInfo);
      var config = {
        method: "post",
        url: apiURL + "ManageModule/UpdateModuleDetails",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      console.log(data);
      this.isLoading = true;
      axios(config)
        .then((result) => {
          this.isLoading = false;
          if (result.data.status_code == 200) {
            this.$swal
              .fire({
                icon: "success",
                title: "Saved",
                text: result.data.message,
                type: "success",
              })
              .then(() => {
                this.$router.push({ path: "Manage_modules" });
              });
          } else {
            //$('#reponse_error').html(result.data.message);
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.message,
            });
          }
        })
        .catch((error) => {
		  this.isLoading = true;
          //var errorObject=JSON.stringify(error.response.data.errors);
          //console.log(errorObject);
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },
  },
};
</script>
